import { VALUE_TYPE_NUMBER } from '@/consts/dict';

export default {
    getDict: () => {
        return {
            data: {
                ['订单状态']: [
                    { label: '未支付', value: 1, valueType: VALUE_TYPE_NUMBER },
                    { label: '待支付', value: 2, valueType: VALUE_TYPE_NUMBER },
                    { label: '交易成功', value: 3, valueType: VALUE_TYPE_NUMBER },
                    { label: '退款中', value: 4, valueType: VALUE_TYPE_NUMBER },
                    { label: '成功退款', value: 5, valueType: VALUE_TYPE_NUMBER },
                    { label: '退款失败', value: 6, valueType: VALUE_TYPE_NUMBER },
                    { label: '用户取消', value: 7, valueType: VALUE_TYPE_NUMBER },
                ],
                // ['卡包类型']: [
                //   { label: '储值卡', value: 1, valueType: VALUE_TYPE_NUMBER },
                //   { label: '多次卡', value: 2, valueType: VALUE_TYPE_NUMBER },
                //   { label: '时效卡', value: 3, valueType: VALUE_TYPE_NUMBER },
                //   { label: 'VIP卡', value: 4, valueType: VALUE_TYPE_NUMBER },
                // ],
                ['场地状态']: [
                    { label: '停用', value: 1, valueType: VALUE_TYPE_NUMBER },
                    { label: '过期', value: 2, valueType: VALUE_TYPE_NUMBER },
                    { label: '可用', value: 3, valueType: VALUE_TYPE_NUMBER },
                    { label: '未支付', value: 4, valueType: VALUE_TYPE_NUMBER },
                    { label: '支付中', value: 5, valueType: VALUE_TYPE_NUMBER },
                    { label: '已预定', value: 6, valueType: VALUE_TYPE_NUMBER },
                    { label: '已锁定', value: 7, valueType: VALUE_TYPE_NUMBER },
                ],
            },
        };
    },
};